const placeholder = document.querySelector('[data-select-placeholder]');
const placeholderContent = placeholder?.querySelector('[data-select-placeholder-content]');
const optionsContainer = document.querySelector('[data-select-options]');
let options = document.querySelectorAll('[data-select-option]');
const selectOptionsUl = document.querySelector('[data-ul-options]');

if (!placeholder || !optionsContainer || !options) return;

options = [...options].sort((a, b) => {
  const numA = parseInt(a.querySelector("span").textContent);
  const numB = parseInt(b.querySelector("span").textContent);
  return numA - numB;
});

placeholderContent.innerText = options[0]?.querySelector('span')?.innerText;
selectOptionsUl.innerHTML = "";
options.forEach(option => selectOptionsUl.appendChild(option));

function toggleSelectMenu() {
  optionsContainer?.classList.toggle('hidden');
  adjustSelectOptionsUl();
}

function handleOutsideClick(e) {
  const placeholderClick = placeholder?.contains(e.target);
  if (placeholderClick) return;
  const outsideClick = !optionsContainer?.contains(e.target);
  if (outsideClick) optionsContainer?.classList.add('hidden');
}

function handleSelect(option) {
  placeholderContent.innerHTML = option.innerHTML;
  optionsContainer?.classList.add('hidden');
}

options.forEach(option => option.addEventListener('click', () => handleSelect(option)))

placeholder?.addEventListener('click', toggleSelectMenu);
document.addEventListener('click', (e) => handleOutsideClick(e));

function adjustSelectOptionsUl() {
  const startPos = selectOptionsUl?.getBoundingClientRect().top;
  if (startPos) {
    const endPosition = window.innerHeight - 105;
    const maxHeight = endPosition - startPos;
    selectOptionsUl.style.maxHeight = `${maxHeight}px`;
  }
}